<section class="n-clientes-section">
  <!-- Botão de Cadastrar Novo Cliente e Campo de Busca -->
  <div class="n-top-section flex flex-column gap-2 mb-2">
    <!-- Botão de Cadastrar Novo Cliente com visual suave e chevron -->
    <div
      class="n-btn-novo-cliente cursor-pointer flex align-items-center justify-content-between p-3"
      (click)="abrirModalNovo()"
      (keydown.enter)="abrirModalNovo()"
      role="button"
      tabindex="0"
    >
      <div class="flex align-items-center gap-2 text-primary font-medium text-sm sm:text-base">
        <i class="pi pi-plus text-primary text-sm font-bold"></i>
        <span>{{ 'BARDO_CLIENTES.CADASTRAR_NOVO' | translate: { termo: $termos().cliente.singular.toLowerCase() } }}</span>
      </div>
      <i class="pi pi-chevron-right text-primary text-xs"></i>
    </div>

    <!-- Campo de Busca -->
    <div class="n-search-box">
      <p-iconfield class="w-full">
        <p-inputicon styleClass="pi pi-search text-primary font-bold" />
        <input
          pInputText
          type="text"
          [ngModel]="pesquisa()"
          (ngModelChange)="onPesquisaInput($event)"
          (keyup.enter)="buscarComFiltro()"
          [placeholder]="$termos().cliente.placeholderBusca"
          class="w-full n-input-search"
        />
        @if (pesquisa()) {
          <p-inputicon styleClass="pi pi-times cursor-pointer text-500" (click)="limparPesquisa()" />
        }
      </p-iconfield>
    </div>
  </div>

  <!-- Contador de Clientes -->
  <div class="n-counter-header mb-2 flex align-items-center justify-content-between">
    <span class="text-xs font-bold text-500 uppercase tracking-wider">
      {{ $total() }} {{ $total() === 1 ? ($termos().cliente.singular | uppercase) : ($termos().cliente.plural | uppercase) }}
    </span>
  </div>

  <!-- Grid de Cards / Skeleton / Empty State -->
  <div class="n-clientes-container">
    @if ($loading() && $clientes().length === 0) {
      <div class="n-skeleton-lista">
        @for (skeleton of skeletonCards; track skeleton) {
          <div class="n-skeleton-item">
            <div class="n-skeleton-avatar"></div>
            <div class="n-skeleton-textos">
              <div class="n-skeleton-linha grande"></div>
              <div class="n-skeleton-linha media"></div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="n-clientes-grid">
        @for (cliente of $clientes(); track cliente.id) {
          <div
            class="n-cliente-card flex w-full align-items-center justify-content-between gap-2 p-2 sm:p-3 cursor-pointer"
            (click)="abrirModalView(cliente)"
            role="button"
            tabindex="0"
          >
            <!-- Conteúdo Principal (Avatar + Nome + Data/Badges inline) -->
            <div class="flex flex-1 align-items-center gap-2 min-w-0">
              <!-- Avatar -->
              <div
                class="n-avatar flex align-items-center justify-content-center text-white font-bold border-circle flex-shrink-0"
                [style.background-color]="getAvatarColor(cliente.id)"
              >
                {{ getIniciais(cliente.nome) }}
              </div>

              <!-- Nome e Informações Metadados -->
              <div class="min-w-0 flex-1 flex flex-column gap-1">
                <h3 class="n-cliente-nome m-0 text-color text-overflow-ellipsis overflow-hidden white-space-nowrap">
                  {{ cliente.nome }}
                </h3>

                @if (cliente.dataNascimento) {
                  <!-- Linha de Data de Nascimento -->
                  <div class="n-birthdate-row flex align-items-center gap-1 text-xs text-500 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="n-icon-cake text-400">
                      <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/>
                      <path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2 1 2 1"/>
                      <path d="M2 21h20"/>
                      <path d="M7 8v3"/>
                      <path d="M12 8v3"/>
                      <path d="M17 8v3"/>
                      <path d="M7 4h.01"/>
                      <path d="M12 4h.01"/>
                      <path d="M17 4h.01"/>
                    </svg>
                    <span>{{ cliente.dataNascimento | date:'dd/MM/yyyy':'UTC' }}</span>
                  </div>
                }

                <!-- Linha de Pílulas -->
                <div class="flex flex-wrap align-items-center gap-1 text-xs text-500 mt-1 min-w-0 max-w-full">
                  @if (cliente.responsavelNome) {
                    <span
                      class="n-pill dependente"
                      [pTooltip]="'BARDO_CLIENTES.DEPENDENTE_DE' | translate: { nome: cliente.responsavelNome }"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-user text-xs"></i> {{ 'BARDO_CLIENTES.RESP_PREFIX' | translate: { nome: cliente.responsavelNome } }}
                    </span>
                  } @else if (cliente.qtdDependentes && cliente.qtdDependentes > 0) {
                    <span
                      class="n-pill responsavel"
                      [pTooltip]="'BARDO_CLIENTES.QTD_DEPENDENTES_VINCULADOS' | translate: { qtd: cliente.qtdDependentes }"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-users text-xs"></i> {{ cliente.qtdDependentes === 1 ? ('BARDO_CLIENTES.DEP' | translate: { count: cliente.qtdDependentes }) : ('BARDO_CLIENTES.DEPS' | translate: { count: cliente.qtdDependentes }) }}
                    </span>
                  }

                  <span class="n-pill phone">
                    <i class="pi pi-phone text-xs"></i>
                    {{ cliente.telefone ? formatarTelefone(cliente.telefone) : ('BARDO_CLIENTES.SEM_TELEFONE' | translate) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Indicador de Ação (Alinhado no topo à direita) -->
            <div class="n-action-container flex align-items-center justify-content-center flex-shrink-0">
              <div class="n-action-circle flex align-items-center justify-content-center border-circle">
                <i class="pi pi-chevron-right text-400 text-xs"></i>
              </div>
            </div>
          </div>
        } @empty {
          @if (!$loading()) {
            @if (pesquisa()) {
              <div class="n-empty-state text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
                <i class="pi pi-search text-4xl block mb-2 text-400"></i>
                <h3 class="m-0 text-base font-semibold text-700">
                  {{ 'BARDO_CLIENTES.NENHUM_ENCONTRADO' | translate: { termo: $termos().cliente.singular.toLowerCase() } }}
                </h3>
                <p class="m-0 text-sm text-500 mt-1">
                  {{ 'BARDO_CLIENTES.NENHUM_RESULTADO_BUSCA' | translate }}
                </p>
              </div>
            } @else {
              <div class="n-empty-state text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
                <i class="pi pi-users text-4xl block mb-2 text-400"></i>
                <h3 class="m-0 text-base font-semibold text-700">
                  {{ 'BARDO_CLIENTES.NENHUM_CADASTRADO' | translate: { termo: $termos().cliente.singular.toLowerCase() } }}
                </h3>
                <p class="m-0 text-sm text-500 mt-1">
                  {{ 'BARDO_CLIENTES.ADICIONE_PRIMEIRO' | translate: { termo: $termos().cliente.singular.toLowerCase() } }}
                </p>
              </div>
            }
          }
        }
      </div>
    }
  </div>

  <!-- Paginação -->
  @if ($total() > 0) {
    <div class="mt-3">
      <p-table
        [value]="$clientes()"
        [paginator]="true"
        [rows]="rows()"
        [first]="first()"
        [totalRecords]="$total()"
        [rowsPerPageOptions]="[10, 20, 30]"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [loading]="$loading()"
        styleClass="p-datatable-borderless n-compact-paginator"
      >
        <ng-template #body let-cliente></ng-template>
      </p-table>
    </div>
  }
</section>

<!-- Modal de Visualização/Edição/Criação -->
<lib-cliente-view-modal
  [visible]="modalViewAberto() || modalEditAberto()"
  [cliente]="clienteSelecionado()?.id ? clienteSelecionado() : null"
  (saved)="onSalvar()"
  (vinculoAlterado)="carregarClientes()"
  (closed)="fecharModal()"
></lib-cliente-view-modal>

<!-- Confirm Dialog -->
<p-confirmDialog></p-confirmDialog>

